import PropTypes from 'prop-types';
import React from 'react';
import CatchNews from './CatchNews';
import CatchPartnerSpecials from './CatchPartnerSpecials';
import BrandDetails from './BrandDetails';
import {
  Button,
  ButtonToolbar,
  ButtonGroup,
} from 'react-bootstrap';
import { Link } from 'react-router';

class TravelManagerHome extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.requestCatchNews();
    this.props.requestCatchPartnerSpecials();
    this.props.requestCatchAnnouncementsConfig();
  }
  render() {
    console.log("catchnews++>",this.props.catchNews);
    const brands =[];
    if(this.props.brands){
      this.props.brands.forEach((brand) => {
        if(brand.logo){
          brands.push(<BrandDetails brand={brand} contacts={this.props.brandsContacts} BrandPopUp={this.props.BrandPopUp}/>);
        }
      });
    }
    return (
      <div className="container-fluid">
        <div className="row landing-center">
          <div className="col-sm-8 col-md-8">
            <div className="col-sm-12 col-md-12">
              <h1>Welcome to Catch!</h1>
            </div>
            <hr />
            <div className="col-sm-12 col-md-12 landing-buttons">
              <Link to="/agency">
              <Button className="btn btn-lg btn-success">
                Invite more team members
              </Button>
              </Link>
              <Link to="/tours">
              <Button className="btn btn-lg btn-success">
              Create Group Travel
              </Button>
              </Link>
            </div>
            <div className="col-sm-12 col-md-12 catch-news-feed">
              <CatchNews
                catchNews={this.props.catchNews}
                catchAnnouncementsConfig={this.props.catchAnnouncementsConfig}
              />
              <div className="catch-partner-special-instruction">
                <p>Search Hotel Specials in the Search Hotels tab on the left</p>
                <i className="fa fa-long-arrow-left catch-partner-special-left-arrow" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div className="col-sm-4 col-md-4">
            <CatchPartnerSpecials
              catchPartnerSpecials={this.props.catchPartnerSpecials}
              catchAnnouncementsConfig={this.props.catchAnnouncementsConfig}
            />
          </div>  
        </div>
        <div className="row landing-center">
          <div className="col-sm-12 col-md-12">
            <h3> Entertainment Contacts and Group info by Brand: </h3><br/>
            {brands}
          </div>
        </div>
      </div>
    );
  }
}

TravelManagerHome.propTypes = {
  catchNews: PropTypes.array,
  catchPartnerSpecials: PropTypes.array,
  catchAnnouncementsConfig: PropTypes.array
};
TravelManagerHome.defaultProps = {
  catchNews: [],
  catchPartnerSpecials: [],
  catchAnnouncementsConfig: []
};

export default TravelManagerHome;


// WEBPACK FOOTER //
// src/routes/home/components/TravelManagerHome.js